import { OrderDocumentOptions } from '../typing/enums';

export function isOrderDrm(options: OrderDocumentOptions) {
	return (options & OrderDocumentOptions.DrmProtected) === OrderDocumentOptions.DrmProtected;
}

export default isOrderDrm;
